export default __webpack_public_path__ + "static/media/photo--lg--141.8c05ff7a.jpg";